<template>
  <svg viewBox="0 0 29 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M28.5 21V18L16.5 10.5V2.25C16.5 1.005 15.495 0 14.25 0C13.005 0 12 1.005 12 2.25V10.5L0 18V21L12 17.25V25.5L9 27.75V30L14.25 28.5L19.5 30V27.75L16.5 25.5V17.25L28.5 21Z"
      fill="currentColor"
    />
  </svg>
</template>
